export enum EConsumptionDistributionApplianceCategory {
  HEATER = "HEATER",
  WATER_HEATER = "WATER_HEATER",
  AIR_CONDITIONING_COOLING = "AIR_CONDITIONING_COOLING",
  HEAT_PUMP = "HEAT_PUMP",
  OTHER = "OTHER",
}
